export default __webpack_public_path__ + "static/media/testing-tablet.d2f6f2b1.jpg";